import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2171f0a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "member-h" }, "マイページ")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "row justify-content-center mt-4"
}
const _hoisted_3 = { class: "col-12 member-name2" }
const _hoisted_4 = {
  key: 1,
  class: "row mt-3 form"
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "氏名", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "メール", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "電話番号", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "郵便番号", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "住所", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "性別", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "生年月日", -1))
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "会員区分", -1))
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "決済方法", -1))

import { Member, WorkHistory, PaymentMethod } from '@/models';
import { Auth, DataStore, SortDirection } from 'aws-amplify';
import {ref, reactive, inject, onMounted, toRefs, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router';

import dayjs from 'dayjs'
import 'dayjs/locale/ja'

interface Props {
  member: Member;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null
  },
  emits: ['stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
}



const { member } = toRefs(props);



const router = useRouter();

watch(member, async() => {
  emit('stopLoading');  
})

const getCode = () => {
  return ('000000' + member.value.codeNum).slice(-6);
}

const logout = async() => {
  try {
    await Auth.signOut();
    router.push('/login');
  }
  catch(e) {
    console.log(e);
  }
}

onMounted(() => {
  addEventListener("popstate", () => {
    router.push("/")
  })
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(member))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(getCode()), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(member).name) + " 様", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(member))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", null, [
              _createElementVNode("tbody", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('edit')))
              }, [
                _createElementVNode("tr", null, [
                  _hoisted_6,
                  _createElementVNode("td", null, _toDisplayString(_unref(member).name), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_7,
                  _createElementVNode("td", null, _toDisplayString(_unref(member).email), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", null, _toDisplayString(_unref(member).tel), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(_unref(member).postCode), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, _toDisplayString(_unref(member).address), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _createElementVNode("td", null, _toDisplayString(_unref(member).gender == 0 ? '男性' : '女性'), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", null, _toDisplayString(_unref(dayjs)(_unref(member).birthday).format('YYYY年MM月DD日')), 1)
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_13, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('monthly')))
                }, [
                  _hoisted_14,
                  _createElementVNode("td", null, _toDisplayString(_unref(member).memberType?.name), 1)
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_15, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('payment')))
                }, [
                  _hoisted_16,
                  _createElementVNode("td", null, _toDisplayString((_unref(member).paymentMethod == 0 ? 'クレジットカード' : 'PayPay')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "btn-width relative",
      onClick: logout
    }, "ログアウト")
  ], 64))
}
}

})